let isStickyVisible = false;
let hasPassedHalf = false;

// GSAP animace ukázání sticky
function showSticky() {
    if (!isStickyVisible) {
        isStickyVisible = true;

        const isDesktop = window.innerWidth > 1200;

        gsap.fromTo(".manaMobileSticky",
            {
                scaleX: 0.05,
                scaleY: 1,

                y: 200,
                x: isDesktop ? "-100%" : "0", // ✨ dynamicky podle šířky
                opacity: 0
            },
            {
                scaleX: 1,
                scaleY: 1,
                y: 0,
                x: isDesktop ? "-100%" : "0", // ✨ dynamicky podle šířky
                opacity: 1,
                duration: 1,
                ease: "elastic.out(1, 1)",
                onStart: () => {
                    gsap.fromTo(".buy-sticky",
                        {
                            scaleX: 0.05,
                            scaleY: 1,
                            y: 200,
                            opacity: 0
                        },
                        {
                            scaleX: 1,
                            scaleY: 1,
                            y: 0,
                            delay: -1,
                            opacity: 1,
                            duration: 0.7,
                            ease: "elastic.out(1, 1)"
                        }
                    );

                    gsap.fromTo(".mainPrice",
                        {
                            x: 20,
                            opacity: 0
                        },
                        {
                            x: 0,
                            opacity: 1,
                            duration: 0.5,
                            delay: 0.4,
                            ease: "power2.out"
                        }
                    );
                }
            }
        );
    }
}

function hideSticky() {
    if (isStickyVisible) {
        isStickyVisible = false;
        gsap.to(".manaMobileSticky", {
            y: 200,        // ➔ sticky jen sjede dolů
            opacity: 0,    // ➔ sticky zmizí
            duration: 0.4,
            ease: "power1.in"
            // scaleX necháme 1, vůbec neměníme
        });
    }
}

// Skrýt sticky při vstupu do sekce
ScrollTrigger.create({
    trigger: "#product-buy-section",
    start: "top bottom",
    end: "bottom top",
    onEnter: hideSticky,
    onEnterBack: hideSticky
});

// Detekce průchodu půlkou obrazovky (dolním okrajem sekce)
ScrollTrigger.create({
    trigger: "#product-buy-section",
    start: "bottom center",
    onEnter: () => {
        hasPassedHalf = true;
    }
});

// Zobrazit sticky až po průchodu půlkou a mimo sekci
ScrollTrigger.create({
    trigger: "body",
    start: "top top",
    end: "bottom bottom",
    onUpdate: () => {
        const section = document.querySelector("#product-buy-section");
        const bounds = section.getBoundingClientRect();
        const isOutOfView = bounds.bottom <= 0 || bounds.top >= window.innerHeight;

        if (hasPassedHalf && isOutOfView) {
            showSticky();
        }
    }
});